export default __webpack_public_path__ + "static/media/logo.7f5cced5.svg";